import { gql } from "@apollo/client";

export const Airport_Query = gql `
query M_airport {
    aatmsv4_airports(limit: 10, order_by: {icao: asc}, where: {active: {_eq: true}}) {
      icao
      iata
      airport
      country
  active
    }
  }
`
export const Airport_Query_false = gql `
query M_airport {
    aatmsv4_airports(limit: 10, order_by: {icao: asc}, where: {active: {_eq: false}}) {
      icao
      iata
      airport
      country
  active
    }
  }
`
export const Insert_Airport = gql`
mutation MyMutation(
  $icao: String!
  $iata: String!
  $airport: String!
  $country: String!
) {
  insert_aatmsv4_airports(objects: {active: true, airport: $airport, country: $country, iata: $iata, icao: $icao}) {
    returning {
      iata
      icao
    }
  }
}
`

export const edit_Airport = gql `
mutation M_airports_edit(
  $icao: String!
  $iata: String!
  $airport: String!
  $country: String!
) {
  update_aatmsv4_airports_by_pk(pk_columns: {icao: $icao}, _set: {active: true, airport: $airport, country: $country, iata: $iata, icao: $icao}) {
    icao
    iata
    airport
    country
    active
  }
}
`